<template>
  <!-- 当前租户下所有用户的登录日志 -->
  <el-container class="pagination-list login-log-container">
    <el-main>
      <div class="content">
        <div class="login-log-operation">
          <el-form :inline="true">
            <el-form-item label="姓名" prop="keyword">
              <el-select
                v-model="filters.userId"
                filterable
                remote
                placeholder="请输入姓名"
                clearable
                :remote-method="remoteMethod"
                :loading="filterLoading">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="processState" label="起始时间">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="filters.startDate" type="datetime" placeholder="请选择起始时间"></el-date-picker>
            </el-form-item>
            <el-form-item prop="processState" label="截止时间">
              <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="filters.endDate" type="datetime" placeholder="请选择截止时间"></el-date-picker>
            </el-form-item>
            <!--操作按钮-->
            <el-form-item class="login-log-operation-buttons operation-buttons">
              <el-button @click="getData">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table class="table-list" :data="loginData" v-loading="loading" height="calc(100% - 34px)">
          <el-table-column property="name" label="姓名" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column property="time" label="登录时间" :formatter="formatDate" align="center"></el-table-column>
          <el-table-column property="address" label="登录地址" align="center"></el-table-column>
          <el-table-column property="deviceType" label="客户端" align="center"></el-table-column>
          <el-table-column property="browser" label="浏览器" align="center"></el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total,sizes, prev, pager, next,jumper "
            :total="pagination.total"
          ></el-pagination>
        </el-footer>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'login-log',
  data () {
    return {
      loading: false,
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loginData: [],
      filters: {
        userId: '',
        // 起始时间默认为当天0点
        startDate: `${moment(new Date()).format('YYYY-MM-DD&HH:mm:ss').split('&').shift()} 00:00:00`,
        endDate: ''
      },
      filterLoading: false,
      options: []
    }
  },
  async created () {
    this.pagination.currentPage = 1
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        let params = {
          index: this.pagination.currentPage,
          size: this.pagination.pageSize,
          filters: this.filters
        }
        await this.$axios.get('/auth-api/login/loginRecord', {params}).then(res => {
          this.loginData = res.data.items || []
          this.pagination.total = res.data.total
        })
      } finally {
        this.$nextTick(() => { this.loading = false })
      }
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getData()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getData()
    },
    formatDate (row, column) {
      let data = row[column.property]
      if (column.property === 'startedTime' && data) {
        return moment(data).format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    async remoteMethod (name) {
      if (name === '') {
        this.options = []
      } else {
        this.filterLoading = true
        try {
          let params = {index: 1, size: 1000, filters: {name, useInvalidAccount: 1}}
          await this.$axios.get('/auth-api/users', {params}).then(res => {
            this.options = res.data.items || []
          })
        } finally {
          this.$nextTick(() => { this.filterLoading = false })
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';
  .pagination-list.login-log-container {
    > .el-main {
      > .content {
        height: calc(100% - 41px);
        > .login-log-operation {
          > .el-form {
            .login-log-operation-buttons {
              float: initial;
            }
            .el-form-item__content {
              .el-date-editor.el-input {
                width: 150px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/login-log.vue